import apiService from './ApiService';

class GroupService {
  listMine() {
    return apiService.get('/api/v1/groups/mine');
  }

  getDetail(groupId) {
    return apiService.get(`/api/v1/groups/${groupId}`);
  }

  create(name, description) {
    return apiService.post('/api/v1/groups', { name, description });
  }

  update(groupId, name, description) {
    return apiService.put(`/api/v1/groups/${groupId}`, { name, description });
  }

  updateScoringMode(groupId, scoringMode) {
    return apiService.put(`/api/v1/groups/${groupId}/scoring-mode`, { scoringMode });
  }

  remove(groupId) {
    return apiService.delete(`/api/v1/groups/${groupId}`);
  }

  leave(groupId) {
    return apiService.post(`/api/v1/groups/${groupId}/leave`, null);
  }

  kickMember(groupId, userId) {
    return apiService.delete(`/api/v1/groups/${groupId}/members/${userId}`);
  }

  listMembers(groupId) {
    return apiService.get(`/api/v1/groups/${groupId}/members`);
  }

  createInvitation(groupId, { maxUses, expiresAt } = {}) {
    return apiService.post(`/api/v1/groups/${groupId}/invitations`, { maxUses, expiresAt });
  }

  previewInvitation(code) {
    return apiService.get(`/api/v1/groups/invitations/${code}`);
  }

  joinViaInvitation(code) {
    return apiService.post(`/api/v1/groups/invitations/${code}/join`, null);
  }

  getRanking(groupId, type = 'DAILY', { periodKey, limit } = {}) {
    const params = new URLSearchParams({ type });
    if (periodKey) params.set('periodKey', periodKey);
    if (limit) params.set('limit', limit);
    return apiService.get(`/api/v1/groups/${groupId}/ranking?${params.toString()}`);
  }

  getStats(groupId) {
    return apiService.get(`/api/v1/groups/${groupId}/stats`);
  }

  getRankingComparison(groupId, { userIds, granularity = 'WEEKLY', periods = 12 } = {}) {
    const params = new URLSearchParams({ userIds: (userIds || []).join(','), granularity, periods });
    return apiService.get(`/api/v1/groups/${groupId}/ranking/comparison?${params.toString()}`);
  }

  getMyStats(groupId) {
    return apiService.get(`/api/v1/groups/${groupId}/stats/me`);
  }

  // Campeonato
  startTournament(groupId, autoRestart) {
    return apiService.post(`/api/v1/groups/${groupId}/tournaments`, { autoRestart });
  }

  getCurrentTournament(groupId) {
    return apiService.get(`/api/v1/groups/${groupId}/tournaments/current`);
  }

  listTournaments(groupId) {
    return apiService.get(`/api/v1/groups/${groupId}/tournaments`);
  }

  getTournament(groupId, tournamentId) {
    return apiService.get(`/api/v1/groups/${groupId}/tournaments/${tournamentId}`);
  }

  // Supervivencia
  startSurvival(groupId, cycleType, autoRestart) {
    return apiService.post(`/api/v1/groups/${groupId}/survivals`, { cycleType, autoRestart });
  }

  getCurrentSurvival(groupId) {
    return apiService.get(`/api/v1/groups/${groupId}/survivals/current`);
  }

  listSurvivals(groupId) {
    return apiService.get(`/api/v1/groups/${groupId}/survivals`);
  }

  getSurvival(groupId, survivalId) {
    return apiService.get(`/api/v1/groups/${groupId}/survivals/${survivalId}`);
  }
}

export default new GroupService();
